(() => {
  // work/global-launch-options-2026-11-03/mixed-envelope/src/ceika-cart-lock.mjs
  var CART_LOCK_NAME = "ceika-configuration-cart";
  var queueKey = Symbol.for("ceika.configuration.cart.queue");
  function withCartLock(callback) {
    if (globalThis.navigator?.locks?.request) return globalThis.navigator.locks.request(CART_LOCK_NAME, callback);
    const next = (globalThis[queueKey] || Promise.resolve()).then(callback);
    globalThis[queueKey] = next.catch(() => {
    });
    return next;
  }

  // work/global-launch-options-2026-11-03/mixed-envelope/src/ceika-cart-envelope.mjs
  var WIRE_KEY = "_ceika_wire_v2";
  var TEXT_KEY = "_ceika_text_v2";
  var MAX_TEXT_BYTES = 8192;
  var MAX_TEXT_RECORDS = 12;
  var check = (ok, error) => {
    if (!ok) throw Error(error);
  };
  var object = (v) => v !== null && typeof v === "object" && !Array.isArray(v);
  var hex = (v) => typeof v === "string" && /^[a-f0-9]{16}$/.test(v);
  var canonical = (value) => JSON.stringify(sort(value));
  function sort(value) {
    if (Array.isArray(value)) return value.map(sort);
    return object(value) ? Object.fromEntries(Object.keys(value).sort().map((k) => [k, sort(value[k])])) : value;
  }
  function parseBounded(raw) {
    check(typeof raw === "string" && new TextEncoder().encode(raw).length <= MAX_TEXT_BYTES, "text_envelope_overflow");
    let at = 0;
    const space = () => {
      while (/[\x20\t\r\n]/.test(raw[at] || "\0")) at++;
    };
    const eat = (c) => {
      space();
      if (raw[at] === c) {
        at++;
        return true;
      }
      return false;
    };
    const string = () => {
      space();
      const start = at;
      check(raw[at++] === '"', "text_envelope_invalid");
      while (at < raw.length) {
        const c = raw[at++];
        if (c === "\\") {
          at++;
          continue;
        }
        if (c !== '"') continue;
        const result2 = JSON.parse(raw.slice(start, at));
        for (const ch of result2) {
          const n = ch.codePointAt(0);
          check(n < 55296 || n > 57343, "text_envelope_invalid");
        }
        return result2;
      }
      throw Error("text_envelope_invalid");
    };
    const value = (depth) => {
      check(depth <= 4, "text_envelope_invalid");
      space();
      if (raw[at] === '"') return string();
      if (eat("{")) {
        const entries = [], keys = /* @__PURE__ */ new Set();
        if (eat("}")) return {};
        do {
          const k = string();
          check(!keys.has(k) && eat(":"), "text_envelope_invalid");
          keys.add(k);
          entries.push([k, value(depth + 1)]);
          check(keys.size <= 84, "text_envelope_invalid");
          if (eat("}")) return Object.fromEntries(entries);
        } while (eat(","));
        throw Error("text_envelope_invalid");
      }
      const token = /^(?:true|false|null|-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)/.exec(raw.slice(at));
      check(token, "text_envelope_invalid");
      at += token[0].length;
      const result2 = JSON.parse(token[0]);
      check(typeof result2 !== "number" || Number.isFinite(result2), "text_envelope_invalid");
      return result2;
    };
    const result = value(0);
    space();
    check(at === raw.length, "text_envelope_invalid");
    return result;
  }
  function parseWireToken(raw) {
    check(typeof raw === "string" && raw.length <= 255, "wire_invalid");
    const [v, token, nonce, pairs, ...rest] = raw.split("|");
    check(v === "2" && !rest.length && hex(token) && hex(nonce) && typeof pairs === "string" && /^(?:[a-f0-9]{4})*$/.test(pairs), "wire_invalid");
    const choices = {};
    let last = -1;
    for (let i = 0; i < pairs.length; i += 4) {
      const k = pairs.slice(i, i + 2);
      check(parseInt(k, 16) > last, "wire_duplicate_or_unsorted_choice");
      last = parseInt(k, 16);
      choices[k] = pairs.slice(i + 2, i + 4);
    }
    return { token, nonce, choices };
  }
  function textRecord(text) {
    check(object(text) && Object.keys(text).length <= 84 && Object.values(text).every((v) => typeof v === "string"), "text_invalid");
    return structuredClone(text);
  }
  function parseTextEnvelope(raw) {
    if (raw == null || raw === "") return { v: 3, b: {} };
    const env = parseBounded(raw);
    check(object(env) && object(env.b) && Object.keys(env.b).length <= MAX_TEXT_RECORDS, "text_envelope_invalid");
    const keys = Object.keys(env).sort().join(",");
    check(env.v === 2 && keys === "b,r,v" && hex(env.r) || env.v === 3 && keys === "b,v", "text_envelope_invalid");
    const b = Object.fromEntries(Object.entries(env.b).map(([n, record]) => {
      check(hex(n), "wire_nonce_invalid");
      if (env.v === 2) return [n, { r: env.r, t: textRecord(record) }];
      check(object(record) && Object.keys(record).sort().join(",") === "r,t" && hex(record.r), "text_envelope_invalid");
      return [n, { r: record.r, t: textRecord(record.t) }];
    }));
    return { v: 3, b };
  }
  function writeTextEnvelope(envelope) {
    const normalized = parseTextEnvelope(JSON.stringify(envelope.v === 3 ? { v: 3, b: envelope.b } : envelope)), records = Object.values(normalized.b);
    const revisions = new Set(records.map((record) => record.r));
    if (revisions.size <= 1) for (const record of records) check(Object.values(record.t).every((value) => value.length <= 1024), "text_v2_field_limit");
    const raw = JSON.stringify(revisions.size > 1 ? normalized : { v: 2, r: records[0]?.r || envelope.r || "0000000000000000", b: Object.fromEntries(Object.entries(normalized.b).map(([nonce, record]) => [nonce, record.t])) });
    check(new TextEncoder().encode(raw).length <= MAX_TEXT_BYTES, "text_envelope_overflow");
    return raw;
  }
  function readWireText(raw, wire) {
    const parsed = typeof wire === "string" ? parseWireToken(wire) : wire;
    const record = parseTextEnvelope(raw).b[parsed.nonce];
    check(record, "text_record_missing");
    check(record.r === parsed.token, "configuration_outdated");
    return record.t;
  }
  function cartRecords(cart) {
    const env = parseTextEnvelope(cart.attributes?.[TEXT_KEY]), records = /* @__PURE__ */ new Map();
    for (const line of cart.items) {
      if (!Object.hasOwn(line.properties || {}, WIRE_KEY)) continue;
      check(!line.parent_relationship?.parent_key, "wire_on_child");
      const parsed = parseWireToken(line.properties[WIRE_KEY]);
      check(!records.has(parsed.nonce), "nonce_collision");
      readWireText(cart.attributes?.[TEXT_KEY], parsed);
      records.set(parsed.nonce, env.b[parsed.nonce]);
    }
    return records;
  }
  function stageTextRecord(raw, token, nonce, text, retainNonces) {
    check(hex(token) && hex(nonce), "wire_invalid");
    const env = parseTextEnvelope(raw), keep = retainNonces == null ? Object.keys(env.b) : retainNonces;
    for (const n of keep) check(env.b[n], "text_record_missing");
    const retained = new Set(keep), b = Object.fromEntries(Object.entries(env.b).filter(([n]) => retained.has(n)));
    const record = { r: token, t: textRecord(text) };
    check(!b[nonce] || canonical(b[nonce]) === canonical(record), "nonce_collision");
    b[nonce] = record;
    return writeTextEnvelope({ v: 3, b });
  }

  // work/global-launch-options-2026-11-03/mixed-envelope/src/legacy-wire-v2.mjs
  var obj = (v) => v !== null && typeof v === "object" && !Array.isArray(v);
  var check2 = (b, e) => {
    if (!b) throw Error(e);
  };
  var cleanKey = (k) => typeof k === "string" && k.length > 0 && k.length <= 120 && !["__proto__", "constructor", "prototype"].includes(k);
  function textRecord2(text) {
    check2(obj(text) && Object.keys(text).length <= 40, "text_invalid");
    for (const [k, v] of Object.entries(text)) check2(cleanKey(k) && typeof v === "string" && v.length <= 1024, "text_invalid");
    return structuredClone(text);
  }
  function stageTextRecord2(raw, token, nonce, text, retainNonces) {
    return stageTextRecord(raw, token, nonce, textRecord2(text), retainNonces);
  }

  // work/global-launch-options-2026-11-03/mixed-envelope/src/active-cart-records.mjs
  function activeCartRecords(cart) {
    if (!cart.items.some((line) => Object.hasOwn(line.properties || {}, WIRE_KEY))) return /* @__PURE__ */ new Map();
    return cartRecords(cart);
  }

  // work/global-launch-options-2026-11-03/mixed-envelope/src/wheel-entry-recovered.mjs
  (() => {
    var ce = Object.create;
    var z = Object.defineProperty;
    var le = Object.getOwnPropertyDescriptor;
    var de = Object.getOwnPropertyNames;
    var ue = Object.getPrototypeOf, pe = Object.prototype.hasOwnProperty;
    var fe = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports);
    var he = (e, t, i, p) => {
      if (t && typeof t == "object" || typeof t == "function") for (let l of de(t)) !pe.call(e, l) && l !== i && z(e, l, { get: () => t[l], enumerable: !(p = le(t, l)) || p.enumerable });
      return e;
    };
    var _e = (e, t, i) => (i = e != null ? ce(ue(e)) : {}, he(t || !e || !e.__esModule ? z(i, "default", { value: e, enumerable: true }) : i, e));
    var te = fe((ee, L) => {
      (function(e, t) {
        typeof L == "object" && L.exports ? L.exports = t() : e.CoiloverControls = t();
      })(typeof globalThis < "u" ? globalThis : ee, function() {
        "use strict";
        let e = (r) => JSON.parse(JSON.stringify(r)), t = Object.freeze({ "Front pillowball mounts": { field: "frontMount", value: "pillowball" }, "Rear pillowball mounts": { field: "rearMount", value: "pillowball" }, "Coilover helper springs": { field: "helperScope", values: ["front", "front_rear"] }, "Custom Pro valving upgrade": { field: "customValving", value: "pro" }, "Coilover OEM height": { field: "height", value: "oem" }, "Coilover extra-low height": { field: "height", value: "extra_low" }, "Coilover lift": { field: "height", value: "lifted" } }), i = Object.freeze(["height", "frontMount", "rearMount", "helperScope", "customValving", "reservoirMount", "hoseLengthCm", "springPair", "frontSpringRateKgMm", "rearSpringRateKgMm", "color"]), p = (r, u) => {
          if (r == null) return [];
          if (!Array.isArray(r) || r.some((_) => typeof _ != "string")) throw Error("Invalid " + u);
          return r;
        }, l = (r) => {
          let u = String(r);
          if (!/^(?:gid:\/\/shopify\/ProductVariant\/)?\d+$/.test(u)) throw Error("Invalid variant restriction");
          return u.split("/").pop();
        }, a = (r, u) => !r.vehicle_profile_id || r.vehicle_profile_id === u.applicationId;
        function f(r) {
          let u = { standard: "standard_pair_v1", softer: "softer_pair_v1", firmer: "firmer_pair_v1" };
          return { height: r.configuration.heightChoices, frontMount: r.axles.front.mounts.options.map((_) => _.key), rearMount: r.axles.rear.mounts.options.map((_) => _.key), helperScope: r.helperScopes, customValving: r.configuration.cores.some((_) => _.startsWith("custom_")) ? ["standard", "pro"] : ["standard"], reservoirMount: r.configuration.cores.some((_) => _.endsWith("_2m")) ? r.configuration.reservoir["2m"] : [], hoseLengthCm: r.configuration.reservoir.hoseLengthsCm, springPair: [.../* @__PURE__ */ new Set(["standard_pair_v1", ...r.springPairs.presets.map((_) => u[_.key] || _.key), ...r.axles.front.spring.choices.length || r.axles.rear.spring.choices.length ? ["custom"] : []])], frontSpringRateKgMm: r.axles.front.spring.choices.map((_) => _.rateKgMm), rearSpringRateKgMm: r.axles.rear.spring.choices.map((_) => _.rateKgMm), color: ["blue", "orange", "green", "silver", "red"] };
        }
        function g(r, u = {}, _ = []) {
          if (!r || !r.configuration || !r.axles) throw Error("Missing coilover technical profile");
          let o = e(r), n = f(r), b = o.policy || {}, v = [...new Set([...p(b.disabledKits, "catalog disabled kits"), ...p(u.disabledKits, "product disabled kits")].map(l))], x = [.../* @__PURE__ */ new Set([...p(b.disabledUpgrades, "catalog disabled upgrades"), ...p(u.disabledUpgrades, "product disabled upgrades")])];
          if (x.some((s) => !Object.hasOwn(t, s))) throw Error("Unsupported coilover upgrade family");
          let d = new Map(_.map((s) => [l(s.variantId), (s.setup === "Pro Racing" ? "pro_racing" : s.setup.toLowerCase()) + "_" + s.damper.slice(-2).toLowerCase()]));
          if (d.size !== _.length || new Set(d.values()).size !== _.length) throw Error("Duplicate native variant bindings");
          if (v.some((s) => !d.has(s))) throw Error("Restricted kit does not belong to this product");
          let h = /* @__PURE__ */ new Set();
          for (let s of [...b.disabledChoices || [], ...u.disabledChoices || []]) {
            if (!i.includes(s.option_key) || !["string", "number"].includes(typeof s.option_value)) throw Error("Invalid coilover choice restriction");
            h.add(s.option_key + ":" + s.option_value);
          }
          let m = [...b.availability || [], ...u.availability || []].filter((s) => a(s, o));
          for (let s of m) if (!i.includes(s.option_key) || !["available_to_order", "temporarily_unavailable", "confirmation_required"].includes(s.status)) throw Error("Invalid coilover availability record");
          function k(s, E) {
            let O = m.filter((K) => K.option_key === s && String(K.option_value) === String(E)), q = O.filter((K) => K.vehicle_profile_id === o.applicationId);
            return !(q.length ? q : O).some((K) => K.status !== "available_to_order");
          }
          function y(s, E) {
            return !(!n[s]?.some((O) => String(O) === String(E)) || h.has(s + ":" + E) || !k(s, E) || x.some((O) => {
              let q = t[O];
              return q.field === s && (q.values || [q.value]).includes(E);
            }));
          }
          let M = [["height", o.configuration.defaultHeight || "lowered"], ["helperScope", "none"], ["customValving", "standard"], ["springPair", "standard_pair_v1"]];
          for (let s of ["front", "rear"]) {
            let E = o.axles[s], O = E.spring;
            O.standardRateKgMm != null && M.push([s + "SpringRateKgMm", O.standardRateKgMm]), M.push([s + "Mount", E.mounts.default]);
          }
          for (let [s, E] of M) if (h.has(s + ":" + E) || !k(s, E)) throw Error("A required/default choice cannot be disabled: " + s);
          let U = new Set(v.map((s) => d.get(s)));
          o.configuration.cores = o.configuration.cores.filter((s) => !U.has(s)), o.configuration.heightChoices = o.configuration.heightChoices.filter((s) => y("height", s)), o.helperScopes = o.helperScopes.filter((s) => s === "none" || y("helperScope", s));
          for (let s of ["front", "rear"]) {
            let E = o.axles[s];
            E.mounts.options = E.mounts.options.filter((O) => O.key === E.mounts.default || y(s + "Mount", O.key)), E.spring.choices = E.spring.choices.filter((O) => y(s + "SpringRateKgMm", O.rateKgMm));
          }
          let $ = (s) => new Set(o.axles[s].spring.choices.map((E) => E.rateKgMm)), F = $("front"), D = $("rear");
          o.springPairs.linkedExactPairs = o.springPairs.linkedExactPairs.filter((s) => F.has(s.frontKgMm) && D.has(s.rearKgMm)), o.springPairs.presets = o.springPairs.presets.filter((s) => F.has(s.frontKgMm) && D.has(s.rearKgMm) && y("springPair", { standard: "standard_pair_v1", softer: "softer_pair_v1", firmer: "firmer_pair_v1" }[s.key] || s.key));
          let P = { customValving: ["standard", "pro"].filter((s) => y("customValving", s)), reservoirMounts: ["coilover", "remote"].filter((s) => y("reservoirMount", s)), hoseLengthsCm: o.configuration.reservoir.hoseLengthsCm.filter((s) => y("hoseLengthCm", s)), colors: ["blue", "orange", "green", "silver", "red"].filter((s) => y("color", s)), customSpringsEnabled: y("springPair", "custom") };
          if (P.hoseLengthsCm.length || (P.reservoirMounts = P.reservoirMounts.filter((s) => s !== "remote")), o.configuration.cores.some((s) => s.endsWith("_2m")) && !P.reservoirMounts.length) throw Error("A 2M build needs a reservoir mounting choice");
          if (!P.colors.length) throw Error("At least one finish is required");
          return o.policy = { ...b, disabledKits: v, disabledUpgrades: x }, { profile: o, runtime: P, policy: { disabledKits: v, disabledUpgrades: x }, enabled: y };
        }
        function c(r, u, _, o = {}) {
          let n = e(u || {});
          n.disabledKits = [...p(n.disabledKits, "disabled kits")], n.disabledUpgrades = [...p(n.disabledUpgrades, "disabled upgrades")], n.disabledChoices = [...n.disabledChoices || []];
          let b = /* @__PURE__ */ new Set(), v = f(r);
          for (let d of o.KitVariants || []) {
            if (String(d.product_id) !== r.productId || !["UPDATE", "DISABLE"].includes(d.command)) throw Error("Invalid kit maintenance row");
            let h = l(d.variant_id);
            if (b.has("kit:" + h)) throw Error("Duplicate kit row");
            b.add("kit:" + h), n.disabledKits = n.disabledKits.filter((m) => l(m) !== h), d.command === "DISABLE" && n.disabledKits.push(h);
          }
          for (let d of o.UpgradeVisibility || []) {
            if (String(d.product_id) !== r.productId || !["UPDATE", "DISABLE"].includes(d.command) || !Object.hasOwn(t, d.family)) throw Error("Invalid upgrade maintenance row");
            if (b.has(d.family)) throw Error("Duplicate upgrade row");
            b.add(d.family), n.disabledUpgrades = n.disabledUpgrades.filter((h) => h !== d.family), d.command === "DISABLE" && n.disabledUpgrades.push(d.family);
          }
          for (let d of o.OptionChoices || []) {
            if (String(d.product_id) !== r.productId || !["UPDATE", "DISABLE"].includes(d.command) || !i.includes(d.option_key) || !v[d.option_key].some((m) => String(m) === String(d.option_value))) throw Error("Invalid choice maintenance row");
            let h = d.option_key + ":" + d.option_value;
            if (b.has(h)) throw Error("Duplicate choice row");
            b.add(h), n.disabledChoices = n.disabledChoices.filter((m) => m.option_key !== d.option_key || String(m.option_value) !== String(d.option_value)), d.command === "DISABLE" && n.disabledChoices.push({ option_key: d.option_key, option_value: String(d.option_value) });
          }
          let x = g(r, n, _);
          return { family: "coilover", schemaVersion: 1, productId: r.productId, productPolicy: n, compiledProfile: x.profile, runtime: x.runtime, applyEnabled: false, checkoutEnabled: false, importEnabled: false };
        }
        return Object.freeze({ families: t, options: i, technicalChoices: f, apply: g, compileChanges: c });
      });
    });
    var ge = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298], C = (e, t) => e >>> t | e << 32 - t;
    function H(e) {
      let t = new TextEncoder().encode(e), i = Math.ceil((t.length + 9) / 64) * 64, p = new Uint8Array(i);
      p.set(t), p[t.length] = 128;
      let l = new DataView(p.buffer), a = t.length * 8;
      l.setUint32(i - 8, Math.floor(a / 4294967296)), l.setUint32(i - 4, a >>> 0);
      let f = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], g = new Uint32Array(64);
      for (let c = 0; c < i; c += 64) {
        for (let d = 0; d < 16; d++) g[d] = l.getUint32(c + d * 4);
        for (let d = 16; d < 64; d++) {
          let h = g[d - 15], m = g[d - 2], k = C(h, 7) ^ C(h, 18) ^ h >>> 3, y = C(m, 17) ^ C(m, 19) ^ m >>> 10;
          g[d] = g[d - 16] + k + g[d - 7] + y >>> 0;
        }
        let [r, u, _, o, n, b, v, x] = f;
        for (let d = 0; d < 64; d++) {
          let h = C(n, 6) ^ C(n, 11) ^ C(n, 25), m = n & b ^ ~n & v, k = x + h + m + ge[d] + g[d] >>> 0, y = C(r, 2) ^ C(r, 13) ^ C(r, 22), M = r & u ^ r & _ ^ u & _, U = y + M >>> 0;
          x = v, v = b, b = n, n = o + k >>> 0, o = _, _ = u, u = r, r = k + U >>> 0;
        }
        for (let [d, h] of [r, u, _, o, n, b, v, x].entries()) f[d] = f[d] + h >>> 0;
      }
      return f.map((c) => c.toString(16).padStart(8, "0")).join("");
    }
    var me = 8192, be = 12, W = (e) => e !== null && typeof e == "object" && !Array.isArray(e);
    var S = (e, t) => {
      if (!e) throw Error(t);
    }, B = (e) => e.toString(16).padStart(2, "0"), ye = (e) => new TextEncoder().encode(e).length, we = (e) => typeof e == "string" && e.length > 0 && e.length <= 120 && !["__proto__", "constructor", "prototype"].includes(e);
    function ve(e) {
      return S(e?.schemaVersion === 2 && /^[a-f0-9]{16}$/.test(e.token) && Array.isArray(e.options), "wire_dictionary_invalid"), new Map(e.options.map(([t, i], p) => [t, { id: B(p), values: new Map(i.map((l, a) => [l, B(a)])) }]));
    }
    var G = (e) => (S(/^[A-Za-z0-9-]{8,80}$/.test(e || ""), "invalid_build_id"), H(e).slice(0, 16));
    function J(e, t, i) {
      S(/^[a-f0-9]{16}$/.test(i), "wire_nonce_invalid"), S(e?.revision === t.revision && W(e.choices), "configuration_outdated");
      let p = ve(t), l = [];
      for (let [f, g] of Object.entries(e.choices)) {
        let c = p.get(f);
        S(c && c.values.has(g), "wire_choice_unknown"), l.push(c.id + c.values.get(g));
      }
      l.sort();
      let a = "2|" + t.token + "|" + i + "|" + l.join("");
      return S(a.length <= 255, "wire_selection_too_large"), a;
    }
    function X(e) {
      S(typeof e == "string" && e.length <= 255 && /^[\x20-\x7e]*$/.test(e), "wire_invalid");
      let [t, i, p, l, ...a] = e.split("|");
      S(t === "2" && !a.length && /^[a-f0-9]{16}$/.test(i) && /^[a-f0-9]{16}$/.test(p) && /^(?:[a-f0-9]{4})*$/.test(l), "wire_invalid");
      let f = {}, g = -1;
      for (let c = 0; c < l.length; c += 4) {
        let r = l.slice(c, c + 2), u = parseInt(r, 16);
        S(u > g, "wire_duplicate_or_unsorted_choice"), g = u, f[r] = l.slice(c + 2, c + 4);
      }
      return { token: i, nonce: p, choices: f };
    }
    function Y(e) {
      S(W(e) && Object.keys(e).length <= 40, "text_invalid");
      for (let [t, i] of Object.entries(e)) S(we(t) && typeof i == "string" && i.length <= 1024, "text_invalid");
      return structuredClone(e);
    }
    const Z = parseTextEnvelope, xe = writeTextEnvelope, Q = stageTextRecord2;
    var ke = _e(te(), 1);
    var A = (e, t) => {
      if (!e) throw Error(t);
    };
    var De = Object.freeze({ custom_pro_valving: { sku: "CEIKA-NATIVE-COIL-VALVING-PRO", baseMinor: 2e4, label: "Coilover Pro Racing valving" }, height_oem: { sku: "CEIKA-NATIVE-COIL-HEIGHT-OEM", baseMinor: 15e3, label: "Coilover factory ride height build" }, height_extra_low: { sku: "CEIKA-NATIVE-COIL-HEIGHT-LOW", baseMinor: 15e3, label: "Coilover extra-low ride height build" }, height_lifted: { sku: "CEIKA-NATIVE-COIL-HEIGHT-LIFT", baseMinor: 23e3, label: "Coilover lifted ride height build" }, front_mount: { sku: "CEIKA-NATIVE-COIL-MOUNT-FRONT", baseMinor: 5e3, label: "Front pillowball top mounts" }, rear_mount: { sku: "CEIKA-NATIVE-COIL-MOUNT-REAR", baseMinor: 5e3, label: "Rear pillowball top mounts" }, front_helpers: { sku: "CEIKA-NATIVE-COIL-HELPERS-FRONT", baseMinor: 7500, label: "Front helper springs" }, front_rear_helpers: { sku: "CEIKA-NATIVE-COIL-HELPERS-BOTH", baseMinor: 15e3, label: "Front and rear helper springs" } });
    function N(e, t) {
      return !e || Object.entries(e).every(([i, p]) => p.includes(t[i]));
    }
    function re(e, t) {
      A(e.enabled === true && e.revision === t.revision, "policy_unavailable_or_outdated");
      let i = {}, p = (l) => {
        for (let a of l || []) N(a.when, t.choices) && (i[a.variantId] = (i[a.variantId] || 0) + a.units);
      };
      for (let l of Object.keys(t.choices)) A(Object.hasOwn(e.options, l), "unknown_option");
      p(e.mandatoryCharges);
      for (let [l, a] of Object.entries(e.options)) {
        let f = t.choices[l];
        if (!N(a.when, t.choices)) {
          A(f === void 0, "inactive_option");
          continue;
        }
        if (A(!a.required || f !== void 0, "required_option_missing"), f === void 0) continue;
        A(Object.hasOwn(a.values, f), "choice_not_allowed"), A(!a.lockedValue || a.lockedValue === f, "locked_option");
        let g = a.values[f];
        A(N(g.when, t.choices) && (!g.whenAny || g.whenAny.some((c) => N(c, t.choices))), "choice_incompatible"), p(g.charges);
      }
      for (let l of Object.keys(t.text || {})) A(Object.hasOwn(e.textFields || {}, l) && typeof t.text[l] == "string" && t.text[l].length <= (e.textFields[l].maxLength || 255), "invalid_text");
      return i;
    }
    var T = (e, t) => {
      if (!e) throw Error(t);
    }, ne = (e) => "gid://shopify/ProductVariant/" + e, Ee = (e) => "wheel_" + e.replace(/[^a-zA-Z0-9_]/g, "_");
    function oe(e, t, i, { allowLockedTest: p = false } = {}) {
      T(i?.family === "wheels" && i.productId === t.productId && i.sourceProfileHash === t.sourceProfileHash, "Wheel validation binding mismatch"), T(p || i.purchaseEnabled === true && i.sharedDictionaryApproved === true, "Wheel purchasing awaits shared validation approval");
      let l = structuredClone(e);
      l.wireDictionary = i.dictionary;
      for (let a of l.groups) {
        let f = i.fullPolicies.find((o) => o.ownerId === ne(a.parentId))?.policy;
        T(f?.productId === "gid://shopify/Product/" + t.productId, "Wheel parent policy missing");
        let g = {};
        for (let o of t.options) o.key.startsWith("delivery-") && o.key !== "delivery-" + parseInt(a.properties.Diameter) || a.properties[o.label] !== void 0 && (g[Ee(o.key)] = a.properties[o.label]);
        let c = { schemaVersion: 1, revision: i.dictionary.revision, choices: g, text: { vehicle: a.properties.Vehicle, width: a.properties["Requested width"], offset: a.properties["Requested offset"], axle: a.properties.Axle } }, r = re(f, c);
        T(Object.keys(r).length === a.fees.length && a.fees.every((o) => r[ne(o.id)] === 1), "Wheel charges disagree with shared policy");
        let u = l.buildId + "-" + a.properties.Axle, _ = G(u);
        a.selection = c, a.nonce = _, Object.assign(a.properties, { _ceika_wire_v2: J(c, i.dictionary, _), _ceika_build: u, _ceika_family: "wheels", _ceika_role: "kit", _ceika_charge_ids: a.fees.map((o) => o.id).join("|"), _ceika_charge_count: String(a.fees.length) });
      }
      return l;
    }
    function ie(e, t) {
      let i = e.wireDictionary.token, p = [...activeCartRecords(t).keys()];
      let l = p.length ? t.attributes?._ceika_text_v2 : "";
      for (let a of e.groups) l = Q(l, i, a.nonce, a.selection.text, p), p.push(a.nonce);
      return { _ceika_text_v2: l };
    }
    var w = (e, t) => {
      if (!e) throw Error(t);
    };
    function se(e, t, i, p, l) {
      w(/^[A-Z]{3}$/.test(p), "Currency unavailable"), w(typeof l == "string" && /^[\w-]{8,100}$/.test(l), "Invalid build ID"), w(["square", "staggered"].includes(t.fitment), "Choose wheel setup");
      let a = t.fitment === "square" ? ["square"] : ["front", "rear"];
      w(t.axles?.length === a.length && a.every((r) => t.axles.some((u) => u.axle === r)), "Select both axle dimensions"), w(typeof t.properties?.Vehicle == "string" && t.properties.Vehicle.trim().length >= 3, "Enter your vehicle before adding the wheels");
      let f = e.baseVariants[0].id, g = (r) => {
        let u = i[r];
        return w(u && u.currency === p && u.available === true && Number.isSafeInteger(u.price) && u.price > 0, "An option is unavailable or its price has changed"), u.price;
      }, c = t.axles.map((r) => {
        let u = t.choices?.construction;
        e.legacyConstructionParity && w(Object.hasOwn(e.constructions, u), "Choose wheel construction");
        let _ = e.legacyConstructionParity ? u === "2" ? e.dimensions.widths : null : e.dimensions?.widths;
        w(Number.isFinite(r.width) && (_ ? _.includes(r.width) : e.legacyConstructionParity ? r.width > 0 : r.width >= 8.5 && r.width <= 12), "Choose an available width for this wheel"), w(r.offset === "help" || Number.isInteger(r.offset) && r.offset >= -100 && r.offset <= 100, "Choose a valid offset");
        let o = { ...t.choices, ...e.options.some((h) => h.key === "width") && (!e.legacyConstructionParity || u === "2") ? { width: String(r.width) } : {}, diameter: e.legacyConstructionParity ? u + "/" + r.diameter : String(r.diameter), ["delivery-" + r.diameter]: r.delivery };
        w(!(o["FORGED_WHEELS-G004"] === "Add" && o["FORGED_WHEELS-G021"] === "Center-Lock (OEM)"), "Choose conversion or OEM centre-lock, not both");
        let n = (h) => !h || Object.entries(h).every(([m, k]) => {
          let y = e.options.find((M) => "wheel_" + M.key.replace(/[^a-zA-Z0-9_]/g, "_") === m);
          return y && k.includes(o[y.key]);
        }), b = e.options.filter((h) => (!h.key.startsWith("delivery-") || h.key === "delivery-" + r.diameter) && n(h.when)), v = [];
        for (let h of b) {
          let m = h.lockedValue || o[h.key], k = h.values.find((y) => y.key === m);
          w(k && n(k.when), "Choose " + h.label), k.chargeVariantId && v.push({ id: k.chargeVariantId, label: h.label + ": " + k.key, price: g(k.chargeVariantId) });
        }
        let x = r.axle === "square" ? 4 : 2, d = { ...t.properties, "Wheel setup": t.fitment, Axle: r.axle, Diameter: r.diameter + " inches", "Requested width": r.width + " inches", "Requested offset": r.offset === "help" ? "Help me choose" : r.offset + " mm", ...Object.fromEntries(b.map((h) => [h.label, h.lockedValue || o[h.key]])), _ceika_wheels_build: l, _ceika_wheels_axle: r.axle, _ceika_wheels_source: e.sourceProfileHash };
        return w(Object.values(d).every((h) => typeof h == "string" && h.length <= 255), "A specification field is too long"), { parentId: f, quantity: x, properties: d, fees: v, unitMinor: g(f) + v.reduce((h, m) => h + m.price, 0) };
      });
      return { buildId: l, currency: p, groups: c, totalMinor: c.reduce((r, u) => r + u.unitMinor * u.quantity, 0) };
    }
    async function ae(e, t) {
      let i = await t("cart.js");
      w(i.currency === e.currency, "Currency changed. Refresh before adding wheels"), w(!i.items.some((f) => f.properties?._ceika_wheels_build === e.buildId), "This wheel build is already in the cart");
      let p = (f) => f.properties?._ceika_wheels_build === e.buildId;
      async function l() {
        let f = await t("cart.js"), g = Object.fromEntries(f.items.filter(p).map((c) => [c.key, 0]));
        Object.keys(g).length && await t("cart/update.js", { updates: g });
      }
      let a;
      try {
        e.wireDictionary && (a = ie(e, i), await t("cart/update.js", { attributes: a }));
        for (let c of e.groups) {
          let r = [{ id: c.parentId, quantity: c.quantity, properties: c.properties }, ...c.fees.map((o) => ({ id: o.id, quantity: c.quantity, parent_id: c.parentId, properties: { ...c.properties._ceika_build ? { _ceika_build: c.properties._ceika_build, _ceika_family: "wheels", _ceika_role: "upgrade", _ceika_component: "wheel-" + o.id } : {}, _ceika_wheels_build: e.buildId, _ceika_wheels_axle: c.properties._ceika_wheels_axle, "Wheel option": o.label } }))], _ = (await t("cart/add.js", { items: r })).items?.find((o) => String(o.variant_id || o.id) === c.parentId && p(o) && o.properties?._ceika_wheels_axle === c.properties._ceika_wheels_axle);
          w(_?.key, "Shopify did not confirm the wheel line");
        }
        let f = await t("cart.js"), g = f.items.filter(p);
        w(f.currency === e.currency, "Cart currency changed"), a && w(f.attributes?._ceika_text_v2 === a._ceika_text_v2, "Wheel text was not saved correctly");
        for (let c of e.groups) {
          let r = g.filter((o) => o.properties._ceika_wheels_axle === c.properties._ceika_wheels_axle), u = r.find((o) => String(o.variant_id) === c.parentId && !o.parent_relationship);
          w(u && u.quantity === c.quantity, "Wheel quantity was not saved correctly"), w(Object.entries(c.properties).every(([o, n]) => u.properties[o] === n), "Wheel specifications were not saved correctly");
          let _ = [{ id: c.parentId, price: c.unitMinor - c.fees.reduce((o, n) => o + n.price, 0) }, ...c.fees];
          w(r.length === _.length, "Unexpected wheel charge lines");
          for (let o of _) {
            let n = r.find((b) => String(b.variant_id) === o.id);
            w(n && n.quantity === c.quantity && n.original_price === o.price, "A wheel charge changed; review the refreshed price"), o.id !== c.parentId && w(n.parent_relationship?.parent_key === u.key && (!c.properties._ceika_build || n.properties._ceika_build === c.properties._ceika_build), "Wheel option was not attached correctly");
          }
        }
        return w(g.reduce((c, r) => c + r.original_price * r.quantity, 0) === e.totalMinor, "Cart total did not match the wheel quote"), { cart: f, items: g, buildId: e.buildId };
      } catch (f) {
        try {
          await l();
        } catch {
          throw Error("Cart verification failed. Check your cart before retrying; some wheel lines may remain.");
        }
        throw f;
      }
    }
    var j = (e, t) => {
      if (!e) throw Error(t);
    }, R = document.querySelector("[data-ceika-wheels-preview]"), V = R?.querySelector("ceika-native-configurator"), I = JSON.parse(R?.querySelector("[data-wheel-commerce-binding]")?.textContent || "null");
    if (V && I?.purchaseEnabled === true) {
      let c = function() {
        j(I.family === "wheels" && I.productId === R.dataset.productId, "Wrong product binding"), j(I.purchaseEnabled === true && I.executionAllowed === true && I.sharedDictionaryApproved === true && I.release?.approved === true && I.release.mode === "production_staged", "Purchase approval is missing"), j(I.dictionary?.token === "0c3df01adfe64568" && /^[1-9][0-9]*$/.test(a), "Native configuration revision changed");
        let n = I.fullPolicies?.[0];
        j(I.fullPolicies?.length === 1 && n.ownerId === I.nativeVariantId && n.policy.variantId === n.ownerId && n.policy.productId === "gid://shopify/Product/" + I.productId && n.policy.purchaseEnabled === true && n.policy.enabled === true, "Native policy is not approved"), j(f === window.Shopify.country, "Your market changed; refresh");
      }, u = function(n) {
        let b = V.dataset.fitment || "square", v = b === "square" ? ["square"] : ["front", "rear"], x = { construction: V.dataset.constructionKey || "2" };
        for (let m of n.options) ["diameter", "width", "construction"].includes(m.key) || m.key.startsWith("delivery-") || (m.key.startsWith("finish-") ? x[m.key] = V.querySelector('[data-finish="' + m.key.slice(7) + '"]')?.value : x[m.key] = V.querySelector('[data-wheel-choice="' + m.key + '"][aria-pressed="true"]')?.dataset.value);
        let d = {};
        for (let m of V.querySelectorAll("[data-spec-label]")) m.value && !m.closest("[hidden]") && (d[m.dataset.specLabel] = m.value);
        let h = v.map((m) => {
          let k = V.querySelector('[data-axle="' + m + '"].ceika-wheel-axle'), y = parseInt(k.querySelector('[data-diameter][aria-pressed="true"]')?.dataset.diameter);
          return { axle: m, diameter: y, width: Number(k.querySelector("[data-width]").value), offset: k.querySelector("[data-offset-mode]").value === "help" ? "help" : Number(k.querySelector("[data-offset]").value), delivery: [...V.querySelectorAll("[data-delivery-group]")].find((M) => parseInt(M.dataset.deliveryGroup) === y)?.querySelector('[aria-pressed="true"]')?.dataset.value };
        });
        return { fitment: b, choices: x, properties: d, axles: h };
      }, _ = function() {
        c();
        let n = window.CeikaWheelMarket;
        j(n && p && n.currency === p.currency, "Native market price is not verified");
        let b = { ...n.catalog, baseVariants: [{ id: a }], legacyConstructionParity: true };
        j(b.sourceProfileHash === I.sourceProfileHash, "Product configuration changed");
        let v = { ...n.prices, [a]: p };
        return oe(se(b, u(b), v, n.currency, "wheel-" + crypto.randomUUID()), b, I);
      }, e = R.querySelector("[data-wheel-cart-add]"), t = R.querySelector("[data-wheel-cart-status]"), i = false, p = null, l = null, a = String(I.nativeVariantId).split("/").pop(), f = window.Shopify.country, g = window.Shopify?.routes?.root || "/";
      async function r(n, b) {
        c(), j(/^\/(?:[a-z0-9-]+\/)*$/i.test(g) && (/^(cart(?:\/(?:add|update|change))?\.js)$/.test(n) || n === "variants/" + a + ".js"), "Unsupported purchase request");
        let v = await fetch(g + n, { credentials: "same-origin", cache: "no-store", method: b ? "POST" : "GET", headers: { Accept: "application/json", ...b ? { "Content-Type": "application/json" } : {} }, ...b ? { body: JSON.stringify(b) } : {}, signal: AbortSignal.timeout(2e4) }), x = await v.json();
        return j(v.ok, x.description || x.message || "Shopify purchase request failed"), x;
      }
      async function o() {
        if (!i) try {
          if (c(), !window.CeikaWheelMarket) return;
          p || (l ||= (async () => {
            let n;
            try {
              n = await r("variants/" + a + ".js");
            } catch {
              n = await r("variants/" + a + ".js");
            }
            j(String(n.id) === a && n.available === true && Number.isSafeInteger(n.price), "Native configuration is not purchasable"), p = { price: n.price, currency: window.CeikaWheelMarket.currency, available: true };
          })().catch((n) => {
            throw l = null, n;
          }), await l), _(), e.dataset.r2PurchaseReady = "true", e.disabled = false, t.textContent = "Protected configuration ready.";
        } catch (n) {
          e.dataset.r2PurchaseReady = "false", e.disabled = true, t.textContent = n.message;
        }
      }
      for (let n of ["ceika:total", "input", "change"]) V.addEventListener(n, () => {
        o();
      });
      e.addEventListener("click", async () => {
        if (!(i || e.dataset.r2PurchaseReady !== "true")) {
          i = true, e.disabled = true, t.textContent = "Checking and adding your complete wheel set\u2026";
          try {
            let n = await withCartLock(() => ae(_(), r));
            t.textContent = "Complete wheel set added and verified.", R.querySelector("[data-wheel-cart-view]").hidden = false, e.textContent = "Wheel set added", e.dataset.r2PurchaseReady = "false";
          } catch (n) {
            t.textContent = n.message;
          } finally {
            i = false;
          }
        }
      }), o();
    }
  })();
})();
